<!--恒岳读书会-->
<template>
    <div class="event-nav-container">
        <div class="museum-title-container" v-show="showMode==='page'">
            <div class="l-museum-title-container">
                <div class="l-t-museum-title-container">劳动实践营</div>
                <div class="l-b-museum-title-container">劳动实践主题班会</div>
            </div>
            <div class="r-museum-title-container">
                <div  class="back-btn-container" @click="backReadMuseum" >⇦返回</div>
            </div>
        </div>
        <div class="event-content-container" v-show="showMode==='page'">
            <div class="labor-card-list">
                <div class="labor-card" v-for="(item,index) in itemList" :key="index" @click="pageMyjr(item)">
                    <div class="labor-card-box">
                        <div class="labor-card-main">
                            <div class="labor-card-title">{{item.itemName}}</div>
                            <div class="labor-card-sub">{{item.itemMonth}}</div>
                        </div>
                        <div class="labor-card-desc">{{item.itemDesc}}</div>
                    </div>
                </div>
            </div>
        </div>

        <!--劳动实践活动列表-->
        <div class="labor-content-container" v-show="showMode==='list'">
            <season-activity-page :item-info="currentItem"
                                museum-key="4"
                                :mark-info="subMarkInfo"
                                @back-page="backToPage"
                                @view-info="viewActivityInfo"/>
        </div>

        <!--劳动实践活动详情-->
        <div class="labor-content-container" v-show="showMode==='info'">
            <museum-activity-info :activity-id="activityId"
                                :mark-info="subMarkInfo"
                                @back-page="backToList"/>
        </div>
    </div>
</template>
<script>
import {listItem} from "@/api/admin/museum"
import seasonActivityPage from "@/components/museumEvent/seasonActivityPage.vue";
import museumActivityInfo from "@/components/museumEvent/museumActivityInfo.vue";

export default {
    name:'laborEventClub',
    components:{seasonActivityPage, museumActivityInfo},
    props:{
        museumId:{
            type: String,
            default:null
        },
        markInfo:{
            type: String,
            default:null
        },
    },
    watch:{
        museumId(newValue,oldValue){
            this.showMode = 'page';
            this.queryItemList();
        },
        markInfo(newValue,oldValue){
            this.showMode = 'page';
            this.queryItemList();
        },
    },
    mounted() {
    },
    created() {
        this.queryItemList();
    },
    data() {
        return {
            showMode:'page',
            itemList:[],
            currentItem:{},
            activityId:'',
            subMarkInfo:'',
            queryItemForm:{
                itemType:'4',
                museumKey:'4',
            },
        }
    },
    methods: {
        queryItemList(){
            listItem(this.queryItemForm).then(res => {
                if (res.data.code === 1) {
                    this.itemList = res.data.data || [];
                }else {
                    this.$message.error(res.data.msg || "请求出错")
                }
            })
        },
        /*查看主题线下活动列表*/
        pageMyjr(item){
            this.currentItem = item;
            this.subMarkInfo = new Date() + '';
            this.showMode = 'list';
        },
        /*查看线下活动详情*/
        viewActivityInfo(item){
            this.activityId = item.activityId;
            this.subMarkInfo = new Date() + '';
            this.showMode = 'info';
        },
        backToPage(){
            this.showMode = 'page';
        },
        backToList(){
            this.showMode = 'list';
        },
        backReadMuseum(){
            this.showMode = 'page';
            this.$emit('back-read-museum', "homePage");
        },
    }
}
</script>
<style>
.event-nav-container{
    width: 100%;
    height: calc(100vh - 90px);
    background: rgba(255,255,255,.5);
    border-radius: 28px;

}
.museum-title-container{
    width: 100%;
    height: 70px;
    display: flex;
    box-sizing: border-box;
    padding: 0 30px 0 30px!important;
}
.l-museum-title-container{
    width: calc(100% - 80px);
    height: 70px;
}
.l-t-museum-title-container{
    width: 100%;
    height: 40px;
    font-weight: bold;
    color: #0d55a4;
    font-size: 17px;
    line-height: 50px;
}
.l-b-museum-title-container{
    width: 100%;
    height: 30px;
    color: #9a9a9a;
    font-size: 14px;
}
.r-museum-title-container{
    width: 80px;
    height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.back-btn-container{
    width: 80px;
    height: 32px;
    background: #0d55a4;
    color: #fff;
    line-height: 32px;
    text-align: center;
    font-size: 15px;
    border-radius: 6px;
    letter-spacing: 3px;
    cursor: pointer;
}

.event-content-container{
    width: 100%;
    height: calc(100% - 70px);
    box-sizing: border-box;
    padding: 10px 20px 20px 20px;
}
.event-content-top-container{
    width: 100%;
    height: 50%;
    display: flex;
    gap: 10px;
}
.event-item-container{
    width: 16.6%;
    height: 100%;
    display: flex;
    border: 10px;
    box-sizing: border-box;
}
.event-item{
    width: 100%;
    height: 100%;
    cursor: pointer;
}
.fygf-bg1{
    background-image: url("../../assets/fms/fms_1.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.fygf-bg2{
    background-image: url("../../assets/fms/fms_2.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.fygf-bg3{
    background-image: url("../../assets/fms/fms_3.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.fygf-bg4{
    background-image: url("../../assets/fms/fms_4.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.fygf-bg5{
    background-image: url("../../assets/fms/fms_5.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.fygf-bg6{
    background-image: url("../../assets/fms/fms_6.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.fygf-bg7{
    background-image: url("../../assets/fms/fms_7.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.fygf-bg8{
    background-image: url("../../assets/fms/fms_8.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.fygf-bg9{
    background-image: url("../../assets/fms/fms_9.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.fygf-bg10{
    background-image: url("../../assets/fms/fms_10.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.fygf-bg11{
    background-image: url("../../assets/fms/fms_11.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.fygf-bg12{
    background-image: url("../../assets/fms/fms_12.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.event-content-bottom-container{
    width: 100%;
    height: 50%;
    display: flex;
    gap: 10px;
}
.event-title{
    width: 100%;
    height: 50px;
    line-height: 60px;
    text-align: center;
    font-size: 17px;
    font-weight: bold;
    color: #0d55a4;
}
.event-desc{
    width: 100%;
    height: 20px;
    line-height: 20px;
    text-align: center;
    font-size: 14px;
    color: #9a9a9a;
}
/* 劳动实践营分类卡片(一行四个，独立类名，不影响其他模块) */
.labor-card-list{
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    align-content: flex-start;
    overflow-y: auto;
    padding-top: 20px;
}
.labor-card{
    width: calc(25% - 15px);
    height: calc((100% - 40px) / 3);
    min-height: 140px;
    flex-shrink: 0;
    background-color: #ffffff;
    border: 2px solid #0d55a4;
    border-radius: 8px;
    box-sizing: border-box;
    padding: 4px;
    cursor: pointer;
    transition: all 0.25s ease;
}
.labor-card:hover{
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0,0,0,0.1);
}
.labor-card-box{
    width: 100%;
    height: 100%;
    border: 1px solid #e99d42;
    border-radius: 6px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 16px 10px;
}
.labor-card-main{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 14px;
    text-align: center;
}
.labor-card-title{
    font-size: 18px;
    color: #0d55a4;
    font-weight: bold;
}
.labor-card-sub{
    font-size: 14px;
    color: #0d55a4;
    font-weight: bold;
}
.labor-card-desc{
    margin-top: 20px;
    font-size: 12px;
    color: #e99d42;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
}
.labor-content-container{
    width: 100%;
    height: 100%;
}
</style>